export const formatNumberToPrice = (value: number) => {
   const convertedNumber = value.toFixed(2);
   return convertedNumber.replace('.', ',');
};
